import { Navigate, Outlet } from "react-router-dom";
import { Spin } from "antd";

import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import { useStateValue } from "../Reducer/reducer";

const ProtectedLayout = () => {
  const [{ isLoggedIn, manualRefresh }] = useStateValue();

  if (manualRefresh) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100vw",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (!isLoggedIn && !manualRefresh) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Header />
      <div style={{ flex: 1, padding: "20px" }}>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default ProtectedLayout;
